var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contacts--list__item"},[_c('p',[_vm._v(_vm._s(_vm.investor.bank.name))]),_c('p',[_vm._v(_vm._s(_vm.investor.account_number))])])])}
var staticRenderFns = []

export { render, staticRenderFns }